<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
      <c-table
        ref="table1"
        title="단위작업 목록"
        :columns="grid1.columns"
        :merge="grid1.merge"
        :data="investigation.sops"
        :gridHeight="gridHeight"
        :editable="editable && isOld"
        :isExcelDown="false"
        :filtering="false"
        :isFullScreen="false"
        :columnSetting="false"
        selection="multiple"
        rowKey="heaMuscleSopId"
        @innerBtnClicked="innerBtnClicked"
        @table-data-change="jobtableDataChange"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn
              v-if="editable && isOld"
              label="LBLREMOVE"
              icon="delete"
              @btnClicked="deleteJob"
            />
            <c-btn
              v-if="editable && isOld"
              label="LBLADD"
              icon="add"
              @btnClicked="addJob"
            />
            <c-btn
              v-show="editable && isOld"
              :isSubmit="isSaveJob"
              :url="saveJobUrl"
              :param="investigation.sops"
              mappingType="PUT"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveJob"
              @btnCallback="saveJobCallback"
            />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'detail'">
            <q-chip
              v-if="props.row.editFlag !== 'C'"
              outline
              square
              dense
              color="blue"
              :clickable="true"
              text-color="white"
              style="margin-bottom: 4px !important"
              @click.stop="rowClick(props.row)"
            >
              ▶
            </q-chip>
          </template>
        </template>
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7">
      <c-table
        ref="table2"
        :title="`[${selectedJob.sopName}] 부담작업 목록`"
        :columns="grid2.columns"
        :data="detailJobs"
        :gridHeight="gridHeight"
        :editable="editable && isOld"
        :isExcelDown="false"
        :filtering="false"
        :isFullScreen="false"
        :columnSetting="false"
        selection="multiple"
        rowKey="heaMuscleHeavyWorkId"
        @table-data-change="tableDataChange"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn
              v-if="editable && isOld && isSelect"
              label="LBLREMOVE"
              icon="delete"
              @btnClicked="deleteDetailJob"
            />
            <c-btn
              v-if="editable && isOld && isSelect"
              label="LBLADD"
              icon="add"
              @btnClicked="addDetailJob"
            />
            <c-btn
              v-show="editable && isOld && isSelect"
              :isSubmit="isSaveDetailJob"
              :url="saveDetailJobUrl"
              :param="detailJobs"
              mappingType="PUT"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveDetailJob"
              @btnCallback="saveDetailJobCallback"
            />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from "quasar";
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "musculoskeletalSystemJob",
  props: {
    investigation: {
      type: Object,
      default: () => ({
        heaInvestigationPlanId: "", // 근골격계 조사계획 일련번호
        plantCd: "", // 사업장코드
        investigationPlanName: "", // 조사계획명
        year: "", // 심사년도
        heaInvestigationStepCd: "", // 진행상태
        investigationStartDate: "", // 조사시작일
        investigationEndDate: "", // 조사종료일
        period: [],
        deptCd: "", // 담당자 부서
        userId: "", // 담당자 id
        investigationDeptCd: "", // 조사부서
        agency: "", // 조사기관
        remark: "", // 비고
        regUserId: "", // 등록자 ID
        chgUserId: "", // 수정자 ID
        sops: [], // 단위작업
        sopTable: [], // 작업분류표
      }),
    },
    popupParam: {
      type: Object,
      default: () => ({
        heaInvestigationPlanId: "",
      }),
    },
    heavyWorks: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    contentHeight: null,
  },
  data() {
    return {
      grid1: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "processName" }
        ],
        columns: [
          {
            name: "processName",
            field: "processName",
            label: "LBLPROCESS",
            align: "center",
            sortable: false,
            innerBtn: true,
            style: "width:200px",
            btns: [
              {
                label: "",
                icon: "add",
                color: "light-blue",
                tooltip: "공정별 단위작업 추가",
              },
            ],
          },
          {
            name: 'processSortOrder',
            field: 'processSortOrder',
            label: '공정<br>정렬순서',
            align: 'center',
            sortable: true,
            style: 'width:40px',
            type: 'number',
          },
          {
            name: "sopName",
            field: "sopName",
            label: "단위작업",
            align: "left",
            sortable: false,
            style: "width:200px",
            type: "text",
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '정렬순서',
            align: 'center',
            sortable: true,
            style: 'width:40px',
            type: 'number',
          },
          {
            name: "detail",
            field: "detail",
            label: "부담작업<br/>상세",
            align: "center",
            sortable: false,
            style: "width:50px",
            type: "custom",
          },
        ],
      },
      grid2: {
        columns: [
          {
            name: "heavyWorkName",
            field: "heavyWorkName",
            label: "부담작업",
            align: "center",
            sortable: false,
            style: "width:70px",
          },
          {
            name: "investigationDate",
            field: "investigationDate",
            label: "조사일자",
            align: "center",
            sortable: false,
            style: "width:100px",
            type: "date",
          },
          {
            name: "userName",
            field: "userName",
            label: "조사자",
            align: "center",
            sortable: false,
            style: "width:100px",
            type: "user",
            userId: "userId",
            // deptCd: 'investigationDeptCd,'
          },
          {
            name: "detailJobContents",
            field: "detailJobContents",
            label: "작업내용",
            align: "left",
            sortable: false,
            style: "width:100px",
            type: "text",
          },
          {
            name: "unitWorkTime",
            field: "unitWorkTime",
            label: "단위작업<br/>시간(초)",
            align: "right",
            sortable: false,
            style: "width:70px",
            type: "number",
          },
          {
            name: "workTime",
            field: "workTime",
            label: "노출시간<br/>(초)",
            align: "right",
            sortable: false,
            style: "width:70px",
            type: "number",
          },
          {
            name: "workCnt",
            field: "workCnt",
            label: "노출빈도<br/>(횟수)",
            align: "right",
            sortable: false,
            style: "width:70px",
            type: "number",
          },
          {
            name: "exposureWeight",
            field: "exposureWeight",
            label: "노출취급<br/>중량(kg)",
            align: "right",
            sortable: false,
            style: "width:70px",
            type: "number",
          },
          {
            name: "assessResult",
            field: "assessResult",
            label: "평가결과",
            align: "center",
            sortable: false,
            style: "width:80px",
          },
          // {
          //   name: 'result',
          //   field: 'result',
          //   label: '결과',
          //   child: [
          //     {
          //       name: 'workTotal',
          //       field: 'workTotal',
          //       label: '최종<br/>노출시간',
          //       align: 'center',
          //       sortable: false,
          //       style: 'width:70px',
          //     },
          //   ]
          // },
        ],
      },
      selectedJob: {
        heaMuscleSopId: "",
        mdmSopId: "",
        sopName: "",
      },
      editable: true,
      isSaveJob: true,
      isSaveDetailJob: true,
      listJobUrl: "",
      listDetailJobUrl: "",
      saveJobUrl: "",
      deleteJobUrl: "",
      saveDetailJobUrl: "",
      deleteDetailJobUrl: "",
      saveDeleteDetailJobUrl: "",
      popupOptions: {
        isFull: false,
        width: "65%",
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {},
  computed: {
    gridHeight() {
      return this.contentHeight ? this.contentHeight - 100 + "px" : "500px";
    },
    detailJobs() {
      let _items = [];
      if (this.investigation.sops && this.investigation.sops.length > 0) {
        let _data = this.$_.find(this.investigation.sops, {
          heaMuscleSopId: this.selectedJob.heaMuscleSopId,
        });
        if (_data) {
          _items = _data.heavyWorks;
        }
      }
      return _items;
    },
    isSelect() {
      return Boolean(this.selectedJob.heaMuscleSopId);
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listJobUrl = selectConfig.hea.muscleSystem.muscleSop.list.url;
      this.saveJobUrl = transactionConfig.hea.muscleSystem.muscleSop.save.url;
      this.deleteJobUrl =
        transactionConfig.hea.muscleSystem.muscleSop.delete.url;
      this.listDetailJobUrl =
        selectConfig.hea.muscleSystem.muscleHeavyWork.list.url;
      this.saveDetailJobUrl =
        transactionConfig.hea.muscleSystem.muscleHeavyWork.save.url;
      this.deleteDetailJobUrl =
        transactionConfig.hea.muscleSystem.muscleHeavyWork.delete.url;
      this.saveDeleteDetailJobUrl =
        transactionConfig.hea.muscleSystem.muscleHeavyWork.savedelete.url;
      // code setting
      // list setting
    },
    getJobs() {
      this.$http.url = this.listJobUrl;
      this.$http.type = "GET";
      this.$http.param = {
        heaInvestigationPlanId: this.popupParam.heaInvestigationPlanId,
      };
      this.$http.request((_result) => {
        this.$set(this.investigation, "sops", _result.data);
        /**
         * 부담작업 목록 clear
         */
        Object.assign(this.$data.selectedJob, this.$options.data().selectedJob);
      });
    },
    getDetailJobs() {
      this.$http.url = this.listDetailJobUrl;
      this.$http.type = "GET";
      this.$http.param = {
        heaMuscleSopId: this.selectedJob.heaMuscleSopId,
      };
      this.$http.request((_result) => {
        let job = this.$_.find(this.investigation.sops, {
          heaMuscleSopId: this.selectedJob.heaMuscleSopId,
        });
        this.$set(job, "heavyWorks", _result.data);
      });
    },
    jobtableDataChange(props, col) {
      if (col.name === 'processSortOrder') {
        this.$_.forEach(this.investigation.sops, _item => {
          if (_item.processCd === props.row.processCd) {
            _item.processSortOrder = props.row.processSortOrder
            if (_item.editFlag !== 'C') {
              _item.editFlag = 'U'
            }
          }
        })
      }
    },
    tableDataChange(props) {
      /**
       * 계산로직
       *  - 일작업 부담비율 (exopsureRate)이 있는 경우 노출시간/단위작업시간의 값을 넘는지 판단 : 노출시간, 단위작업시간 필수*
       *  - 부담작업표에 노출빈도(횟수)가 관리되어 있으면 입력한 노출빈도(횟수)의 값을 넘는지 판단
       *  - 부담작업표에 노출취급중량(kg)이 관리되어 있으면 입력한 노출취급중량(kg)의 값을 넘는지 판단
       *
       *  = 위의 조건 중 해당되며 모두 만족을 했을 시 부담작업으로 규정
       */
      let work = this.$_.find(this.heavyWorks, {
        heaHeavyWorkNo: props.row.heaHeavyWorkNo,
      });
      if (this.heavyWorks && this.heavyWorks.length > 0 && work) {
        let valid = {
          // 관리되고 있지 않으며 true
          exopsureRate:
            work.exopsureRate && Number(work.exopsureRate) > 0 ? false : true,
          exopsureCnt:
            work.exopsureCnt && Number(work.exopsureCnt) > 0 ? false : true,
          exopsureWeight:
            work.exopsureWeight && Number(work.exopsureWeight) > 0
              ? false
              : true,
        };
        if (!valid.exopsureRate) {
          let _unitWorkTime =
            props.row["unitWorkTime"] && !isNaN(props.row["unitWorkTime"])
              ? Number(props.row["unitWorkTime"])
              : 0;
          let _workTime =
            props.row["workTime"] && !isNaN(props.row["workTime"])
              ? Number(props.row["workTime"])
              : 0;
          valid.exopsureRate =
            _workTime / _unitWorkTime >= Number(work.exopsureRate);
        }
        if (!valid.exopsureCnt) {
          let _workCnt =
            props.row["workCnt"] && !isNaN(props.row["workCnt"])
              ? Number(props.row["workCnt"])
              : 0;
          valid.exopsureCnt = _workCnt >= Number(work.exopsureCnt);
        }
        if (!valid.exopsureWeight) {
          let _exposureWeight =
            props.row["exposureWeight"] && !isNaN(props.row["exposureWeight"])
              ? Number(props.row["exposureWeight"])
              : 0;
          valid.exopsureWeight = _exposureWeight >= Number(work.exopsureWeight);
        }

        // 과거시점
        let preAssessResult = this.$_.clone(props.row.assessResult);
        this.$set(
          props.row,
          "assessResult",
          valid.exopsureRate && valid.exopsureCnt && valid.exopsureWeight
            ? "O"
            : "X"
        );
        /**
         * assessResult의 기존값과 변경된 값을 비교한 뒤 변경된 row들만 editFlag = 'U'로 변경
         * 과거의 값에 대한 변수, 변경된 값에 대한 변수를 이용하여 비교
         * 둘의 값이 달라졌다면 editFlag를 'U'로 입력
         */
        // 바뀐시점
        let afterAssessResult = this.$_.clone(props.row.assessResult);
        if (
          preAssessResult !== afterAssessResult &&
          props.row["editFlag"] !== "C"
        ) {
          props.row["editFlag"] = "U";
          props.row["chgUserId"] = this.$store.getters.user.userId;
        }
      }
    },
    datachange(props) {
      if (props.row["editFlag"] !== "C") {
        props.row["editFlag"] = "U";
        props.row["chgUserId"] = this.$store.getters.user.userId;
      }
    },
    innerBtnClicked(col, props) {
      if (col.name === "processName") {
        this.investigation.sops.splice(props.rowIndex, 0, {
          heaMuscleSopId: uid(),
          heaInvestigationPlanId: this.popupParam.heaInvestigationPlanId,
          heaMuscleSopStepCd: "HMS000001", // 진행상태
          processCd: props.row.processCd,
          processName: props.row.processName,
          processSortOrder: props.row.processSortOrder,
          mdmSopId: "",
          sopName: "",
          heaInvestigationTypeCd: null, // 조사구분
          investigationStartDate: null, // 조사일시
          deptCd: null, // 조사자 부서
          userId: null, // 조사자 id
          remark: "", // 비고
          workers: [],
          heavyWorks: [],
          editFlag: "C",
          regUserId: this.$store.getters.user.userId,
        });
      }
    },
    addJob() {
      this.popupOptions.title = "공정 검색";
      this.popupOptions.param = {
        type: "multiple",
        isAll: true,
        isMultiDept: true,
        multiDeptCd: this.investigation.investigationDeptCd
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/common/process/processPop.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeJobPopup;
    },
    closeJobPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        // let _data = [];
        this.$_.forEach(data, (item) => {
          let _processCd = item.upProcessCd ? item.upProcessCd : item.processCd
          let idx = this.$_.findIndex(this.investigation.sops, {processCd: _processCd})
          let _processSortOrder = 0
          if (idx === -1) { 
            idx = 0
          } else {
            _processSortOrder = this.investigation.sops[idx].processSortOrder
          }
          
          this.investigation.sops.splice(idx, 0, {
            heaMuscleSopId: uid(),
            heaInvestigationPlanId: this.popupParam.heaInvestigationPlanId,
            heaMuscleSopStepCd: "HMS000001", // 진행상태
            processCd: _processCd,
            processName: item.upProcessName ? item.upProcessName : item.processName,
            mdmSopId: "",
            processSortOrder: _processSortOrder,
            sopName: item.upProcessCd ? item.processName : '',
            heaInvestigationTypeCd: null, // 조사구분
            investigationStartDate: null, // 조사일시
            deptCd: null, // 조사자 부서
            userId: null, // 조사자 id
            remark: "", // 비고
            workers: [],
            heavyWorks: [],
            editFlag: "C",
            regUserId: this.$store.getters.user.userId,
          })
        });
        // this.investigation.sops = this.$_.concat(
        //   this.investigation.sops,
        //   _data
        // );
      }
    },
    deleteJob() {
      let selectData = this.$refs[`table1`].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGREMOVE", // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteJobUrl;
            this.$http.type = "DELETE";
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit("APP_REQUEST_SUCCESS");
              this.getJobs();
              this.$refs[`table1`].$refs["compo-table"].clearSelection();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    saveJob() {
      if (this.$comm.validTable(this.grid1.columns, this.investigation.sops)) {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGSAVE", // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSaveJob = !this.isSaveJob;
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      } else {
        window.getApp.$emit("APP_VALID_ERROR");
      }
    },
    saveJobCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getJobs();
    },
    rowClick(row) {
      if (row.editFlag === "C") {
        Object.assign(this.$data.selectedJob, this.$options.data().selectedJob);
      } else {
        this.$set(this.selectedJob, "heaMuscleSopId", row.heaMuscleSopId);
        // this.$set(this.selectedJob, 'mdmSopId', row.mdmSopId)
        this.$set(
          this.selectedJob,
          "sopName",
          row.sopName ? row.sopName : "단위작업을 추가하세요."
        );
      }
    },
    addDetailJob() {
      this.popupOptions.title = "부담작업"; // 부담작업
      this.popupOptions.param = {
        data: this.detailJobs,
      };
      this.popupOptions.target = () => import(`${"./worksheetPop.vue"}`);
      this.popupOptions.width = "90%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeDetailJobPopup;
    },
    closeDetailJobPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        /**
         * 실제 저장/삭제 한 후 유해요인 조사 요청 하기전에
         * 작업내용 및 평가결과 입력되어 있는지 판단하게 처리
         */
        let _addData = [];
        for (let key in data[0]) {
          if (
            data[0][key] === "Y" &&
            this.$_.findIndex(this.detailJobs, { heaHeavyWorkNo: key }) === -1
          ) {
            _addData.push({
              heaMuscleHeavyWorkId: uid(),
              heaMuscleSopId: this.selectedJob.heaMuscleSopId,
              heaInvestigationPlanId: this.popupParam.heaInvestigationPlanId,
              mdmSopId: this.selectedJob.mdmSopId,
              plantCd: this.investigation.plantCd,
              heaHeavyWorkNo: key, // 부담작업No
              heavyWorkName: `${key}항`, // 부담작업No명 `${key}항`
              userId: this.$store.getters.user.userId, // 조사자
              userName: this.$store.getters.user.userName, // 조사자
              deptCd: this.$store.getters.user.deptCd, // 조사자 부서
              investigationDate: this.$comm.getToday(), // 조사일자
              detailJobContents: "", // 작업내용
              unitWorkTime: null, // 단위작업시간
              workTime: null, // 작업시간
              workCnt: null, // 작업횟수
              exposureWeight: null, // 노출취급중량(kg)
              workTotal: null, // 총 노출시간
              assessResult: "", // 평가결과
              workload: null, // 작업부하
              workFrequency: null, // 작업빈도
              totalScore: null, // 총 점수
              editFlag: "C",
              regUserId: this.$store.getters.user.userId,
            });
          }
        }
        let _deleteData = [];
        this.$_.forEach(this.detailJobs, (item) => {
          if (
            this.$_.findIndex(Object.entries(data[0]), (_item) => {
              return (
                String(_item[0]) === String(item.heaHeavyWorkNo) &&
                _item[1] === "N"
              );
            }) > -1
          ) {
            _deleteData.push(item);
            return;
          }
        });
        let job = this.$_.find(this.investigation.sops, {
          heaMuscleSopId: this.selectedJob.heaMuscleSopId,
        });
        // this.$set(job, 'heavyWorks', this.$_.concat(job.heavyWorks, _addData))

        /**
         * 삭제 처리
         */
        let _deleteDetailJobs = [];
        this.$_.forEach(_deleteData, (item) => {
          if (item.editFlag !== "C") {
            _deleteDetailJobs.push(item);
          }
        });
        this.$http.url = this.saveDeleteDetailJobUrl;
        this.$http.type = "PUT";
        this.$http.param = {
          saveHeavyWorks: this.$_.concat(job.heavyWorks, _addData),
          deleteHeavyWorks: _deleteDetailJobs,
        };
        this.$http.request(() => {
          window.getApp.$emit("APP_REQUEST_SUCCESS");
          this.getDetailJobs();
        });
      }
    },
    deleteDetailJob() {
      let selectData = this.$refs[`table2`].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGREMOVE", // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteDetailJobUrl;
            this.$http.type = "DELETE";
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit("APP_REQUEST_SUCCESS");
              this.getDetailJobs();
              this.$refs[`table2`].$refs["compo-table"].clearSelection();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    saveDetailJob() {
      if (this.$comm.validTable(this.grid2.columns, this.detailJobs)) {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGSAVE", // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSaveDetailJob = !this.isSaveDetailJob;
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      } else {
        window.getApp.$emit("APP_VALID_ERROR");
      }
    },
    saveDetailJobCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      // this.getDetailJobs();
      this.$emit("getDetail");
    },
  },
};
</script>
